// import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
// import { RouterName } from "@/enums/router-name"; // 导入路由名称枚举
// import IndustryBackground from '@/views/industry-background/IndustryBackground.vue';

// const routes: Array<RouteRecordRaw> = [
//   {
//     path: "/:pathMatch(.*)*",
//     redirect: "/404",
//   },
//   {
//     path: "/404",
//     component: () => import("@/views/error/404.vue"),
//   },
//   {
//     path: "/",
//     name: "yin-container",
//     component: () => import("@/views/YinContainer.vue"),
//     children: [
//       // 一级路由：首页
//       {
//         path: RouterName.Home, // 对应路径："/"
//         name: "home",
//         component: () => import("@/views/Home.vue"),
//       },
      
//       // 一级路由：推荐
//       {
//         path: RouterName.Recommend, // 对应路径："/recommend"
//         name: "recommend",
//         component: () => import("@/views/recommend/Recommend.vue"),
//       },
//       // 推荐详情页（参数路由）
//       {
//         path: "/recommend-detail/:id",
//         name: "recommend-detail",
//         component: () => import("@/views/recommend/RecommendDetail.vue"),
//       },
      
//       // 一级路由：关于我们（包含二级路由）
//       {
//         path: RouterName.Info, // 对应路径："/info"
//         name: "info",
//         component: () => import("@/views/Info.vue"),
//         meta: {
//           navId: 2,
//           navName: '关于我们'
//         },
//         children: [
//           // 关于我们的二级路由
//           {
//             path: RouterName.CompanyProfile.replace(RouterName.Info + '/', ''), // 路径："company-profile"（嵌套在/info下）
//             name: "company-profile",
//             component: () => import("@/views/info/CompanyProfile.vue"), // 假设组件路径
//           },
//           {
//             path: RouterName.DevelopmentHistory.replace(RouterName.Info + '/', ''),
//             name: "development-history",
//             component: () => import("@/views/info/DevelopmentHistory.vue"),
//           },
//           {
//             path: RouterName.BusinessIntro.replace(RouterName.Info + '/', ''),
//             name: "business-intro",
//             component: () => import("@/views/info/BusinessIntro.vue"),
//           },
//           {
//             path: RouterName.TeamIntro.replace(RouterName.Info + '/', ''),
//             name: "team-intro",
//             component: () => import("@/views/info/TeamIntro.vue"),
//           },
//           {
//             path: RouterName.OrgStructure.replace(RouterName.Info + '/', ''),
//             name: "org-structure",
//             component: () => import("@/views/info/OrgStructure.vue"),
//           },
//           {
//             path: RouterName.RDCapability.replace(RouterName.Info + '/', ''),
//             name: "rd-capability",
//             component: () => import("@/views/info/RDCapability.vue"),
//           },
//           {
//             path: RouterName.Honors.replace(RouterName.Info + '/', ''),
//             name: "honors",
//             component: () => import("@/views/info/Honors.vue"),
//           },
//         ],
//       },
      
//       // 一级路由：联系我们
//       {
//         path: RouterName.Contact, // 对应路径："/contact"
//         name: "contact",
//         component: () => import("@/views/Contact.vue"),
//       },
      
//       // 一级路由：行业背景（包含二级路由）
//       {
//         path: RouterName.IndustryBackground, // 对应路径："/industry-background"
//         name: "industry-background",
//         component: IndustryBackground, // 假设组件路径
//         meta: { targetModule: 0 },
//         children: [
//           // 行业背景的二级路由
//           // {
//           //   path: RouterName.StartupMotivation.replace(RouterName.IndustryBackground + '/', ''),
//           //   name: "startup-motivation",
//           //   component: IndustryBackground, // 子路由共用同一组件
//           //   meta: { targetModule: 2 } // 对应"创业动因"模块索引
//           // },
//           // {
//           //   path: RouterName.TechPainPoints.replace(RouterName.IndustryBackground + '/', ''),
//           //   name: "tech-pain-points",
//           //   component: IndustryBackground, // 子路由共用同一组件
//           //   meta: { targetModule: 3 } // 对应"技术痛点"模块索引
//           // },
//           // {
//           //   path: RouterName.ApplicationScenarios.replace(RouterName.IndustryBackground + '/', ''),
//           //   name: "application-scenarios",
//           //   component: IndustryBackground, // 子路由共用同一组件
//           //   meta: { targetModule: 4 } // 对应"应用场景"模块索引
//           // },
//         ],
//       },

//       {
//         path: RouterName.ProductionDetail,
//         name: "production-detail",
//         component: () => import("@/views/product-solution/ProductionDetail.vue"),
//       },
//       {
//         path: RouterName.NewsCenter,
//         name: "news-center",
//         component: () => import("@/views/NewsCenter.vue"),
//       },
      
//       // 一级路由：产品方案（包含二级路由）
//       {
//         path: RouterName.ProductSolution, // 对应路径："/product-solution"
//         name: "product-solution",
//         component: () => import("@/views/product-solution/ProductSolution.vue"), // 假设组件路径
//         redirect: { name: "overview" }, // 添加这行：重定向到 Overview
//         children: [
//           {
//             path: RouterName.Overview.replace(RouterName.ProductSolution + '/', ''),
//             name: "overview",
//             component: () => import('@/views/product-solution/Overview.vue'),
//           },
//           // 产品方案的二级路由
//           {
//             path: RouterName.TechAdvantages.replace(RouterName.ProductSolution + '/', ''),
//             name: "tech-advantages",
//             component: () => import("@/views/product-solution/TechAdvantages.vue"),
//           },
//           {
//             path: RouterName.CoreBusiness.replace(RouterName.ProductSolution + '/', ''),
//             name: "core-business",
//             component: () => import("@/views/product-solution/CoreBusiness.vue"),
//           },
//           {
//             path: RouterName.ProductsInResearch.replace(RouterName.ProductSolution + '/', ''),
//             name: "products-in-research",
//             component: () => import("@/views/product-solution/ProductsInResearch.vue"),
//           },
//           {
//             path: RouterName.UseCases.replace(RouterName.ProductSolution + '/', ''),
//             name: "use-cases",
//             component: () => import("@/views/product-solution/UseCases.vue"),
//           },
//           {
//             path: RouterName.Partners.replace(RouterName.ProductSolution + '/', ''),
//             name: "partners",
//             component: () => import("@/views/product-solution/Partners.vue"),
//           },
//         ],
//       },
      
//       // 一级路由：发展规划（包含二级路由）
//       {
//         path: RouterName.DevelopmentPlan, // 对应路径："/development-plan"
//         name: "development-plan",
//         component: () => import("@/views/development-plan/DevelopmentPlan.vue"), // 假设组件路径
//         children: [
//           // 发展规划的二级路由
//           {
//             path: RouterName.BusinessModel.replace(RouterName.DevelopmentPlan + '/', ''),
//             name: "business-model",
//             component: () => import("@/views/development-plan/BusinessModel.vue"),
//           },
//           {
//             path: RouterName.StrategicGoals.replace(RouterName.DevelopmentPlan + '/', ''),
//             name: "strategic-goals",
//             component: () => import("@/views/development-plan/StrategicGoals.vue"),
//           },
//           {
//             path: RouterName.FinancingNeeds.replace(RouterName.DevelopmentPlan + '/', ''),
//             name: "financing-needs",
//             component: () => import("@/views/development-plan/FinancingNeeds.vue"),
//           },
//         ],
//       },
      
//       // 票务详情页
//       {
//         path: "/ticket-sheet-detail/:id",
//         name: "ticket-sheet-detail",
//         component: () => import("@/views/TicketSheetDetail.vue"),
//       },
//     ],
//   },
// ];

// const router = createRouter({
//   history: createWebHistory(process.env.BASE_URL),
//   routes,
// });

// export default router;
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { HttpManager } from "@/api";
import { MOBILE_MAX_WIDTH } from "@/utils/mobile";

// 父路由布局组件（用于有子路由的路由）
const RouterViewLayout = () => import('@/components/layouts/RouterViewLayout.vue');

// 根据终端类型选择组件（同一路由：移动端/PC端）
const isMobileTerminal = () => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth <= MOBILE_MAX_WIDTH;
};

const resolveByTerminal = (mobileComponent, pcComponent) => {
  return () => (isMobileTerminal() ? mobileComponent() : pcComponent());
};

// 页面风格映射到通用组件
const pageStyleComponents = {
  'card-grid': resolveByTerminal(
    () => import("@/components/layouts/card-grid.vue"),
    () => import("@/components/layouts/card-grid-pc.vue")
  ),         // 卡片网格布局（行业、产品等）
  'news-list': resolveByTerminal(
    () => import("@/components/layouts/news-list.vue"),
    () => import("@/components/layouts/news-list-pc.vue")
  ),         // 新闻列表布局
  'rich-text': resolveByTerminal(
    () => import("@/components/layouts/rich-text.vue"),
    () => import("@/components/layouts/rich-text-pc.vue")
  ),        // 富文本展示布局（关于我们等）
  'parent-layout': resolveByTerminal(
    () => import("@/components/layouts/ParentRouteLayout.vue"),
    () => import("@/components/layouts/ParentRouteLayout-pc.vue")
  ), // 通用父路由容器布局（带横幅+二级导航）
  'industry-bg': resolveByTerminal(
    () => import("@/views/industry-background/IndustryBackground.vue"),
    () => import("@/views/industry-background/IndustryBackground-pc.vue")
  ), // 行业背景页面（左侧导航+滚动模块）
  'default': resolveByTerminal(
    () => import("@/views/Home.vue"),
    () => import("@/views/Home-pc.vue")
  )                          // 默认布局
};

// 页面模板组件映射（预设的通用页面组件）
const pageTemplateS = {
  // 一级路由对应的页面
  'home': resolveByTerminal(
    () => import("@/views/Home.vue"),
    () => import("@/views/Home-pc.vue")
  ),
  'info': () => import("@/views/Info.vue"),
  'contact': () => import("@/views/Contact.vue"),
  'industry-background': resolveByTerminal(
    () => import("@/views/industry-background/IndustryBackground.vue"),
    () => import("@/views/industry-background/IndustryBackground-pc.vue")
  ),
  'production-detail': () => import("@/views/product-solution/ProductionDetail.vue"),
  'news-center': () => import("@/views/NewsCenter.vue"),
  'product-solution': () => import("@/views/product-solution/ProductSolution.vue"),
  'development-plan': () => import("@/views/development-plan/DevelopmentPlan.vue"),
};


// 静态路由（错误页面等）
const staticRoutes: Array<RouteRecordRaw> = [
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
  {
    path: "/404",
    component: () => import("@/views/error/404.vue"),
  }
];

// 动态生成路由的函数
async function generateDynamicRoutes(): Promise<Array<RouteRecordRaw>> {
  try {
    // 从后端获取导航配置
    const navData = await HttpManager.getNavigationConfig() as { data: any };
    // 转换为路由配置
    return buildRouteTree(navData.data);
  } catch (error) {
    console.error("加载导航配置失败:", error);
    return [];
  }
}

// 构建路由树
function buildRouteTree(navList): Array<RouteRecordRaw> {
  const routes: Array<RouteRecordRaw> = [];
  
  console.log('==================== 开始构建路由树 ====================');
  console.log('导航数据:', navList);
  
  // 一级导航（parentId 为 null）
  const rootNavs = navList.filter(nav => !nav.parentId);
  
  rootNavs.forEach(nav => {
    console.log(`\n📌 处理一级路由: ${nav.routePath} (${nav.name})`);
    console.log('  - pageStyle:', nav.pageStyle);
    console.log('  - routeKey:', nav.routeKey);
    
    // 查找子导航
    const children = navList.filter(child => child.parentId === nav.id);
    
    // 选择父路由自己的内容组件
    let parentContentComponent;
    if (nav.pageStyle && pageStyleComponents[nav.pageStyle]) {
      parentContentComponent = pageStyleComponents[nav.pageStyle];
      console.log(`✓ 路由 ${nav.routePath} (${nav.name}) 内容组件使用 pageStyle: ${nav.pageStyle}`);
    } else {
      // 尝试从 pageTemplateS 查找（仅用于特殊页面如 home, info 等）
      const pathKey = nav.routePath.replace(/^\//, '').replace(/\//g, '-');
      parentContentComponent = pageTemplateS[pathKey] || pageTemplateS[nav.routePath.replace('/', '')];
      
      // 如果仍未找到
      if (!parentContentComponent) {
        // 如果有 routeKey，说明是数据驱动页面，默认使用卡片网格布局
        if (nav.routeKey) {
          console.warn(`⚠ 路由 ${nav.routePath} (${nav.name}) 未配置 pageStyle 但有 routeKey，默认使用卡片网格布局`);
          parentContentComponent = pageStyleComponents['card-grid'];
        } else {
          console.warn(`⚠ 路由 ${nav.routePath} (${nav.name}) 未配置 pageStyle 和 routeKey，使用默认布局`);
          parentContentComponent = pageStyleComponents['default'];
        }
      }
    }
    
    // 判断是否使用具有子路由的父布局容器（parent-layout 自带 <router-view>）
    const isParentLayoutStyle = nav.pageStyle === 'parent-layout';
    
    const route: RouteRecordRaw = {
      path: nav.routePath,
      name: `nav-${nav.id}`,
      // parent-layout 本身就包含 <router-view>，直接使用；其他有子路由的用 RouterViewLayout
      component: children.length > 0 && !isParentLayoutStyle ? RouterViewLayout : parentContentComponent,
      meta: {
        navId: nav.id,
        navName: nav.name,
        routeKey: nav.routeKey,
        pageStyle: nav.pageStyle
      }
    };
    
    // 添加子路由
    if (children.length > 0) {
      console.log(`  └─ 找到 ${children.length} 个子路由`);
      
      // 如果使用 parent-layout，它自带 <router-view>，直接添加子路由
      // 如果不是 parent-layout，需要添加索引路由显示父路由内容
      const childRoutes = [];
      
      if (!isParentLayoutStyle && (nav.pageStyle || nav.routeKey)) {
        // 非 parent-layout 的父路由，如果有内容配置，添加索引子路由
        console.log(`  ✓ 父路由使用 RouterViewLayout，添加索引子路由显示内容`);
        childRoutes.push({
          path: '',
          name: `nav-${nav.id}-index`,
          component: parentContentComponent,
          meta: {
            navId: nav.id,
            navName: nav.name,
            routeKey: nav.routeKey,
            pageStyle: nav.pageStyle,
            isIndexRoute: true
          }
        });
      } else if (isParentLayoutStyle) {
        console.log(`  ✓ 父路由使用 parent-layout，自带横幅和导航`);
      }
      
      // 添加其他子路由
      route.children = [
        ...childRoutes,
        ...children.map(child => {
          console.log(`\n  📍 处理子路由: ${child.routePath} (${child.name})`);
          console.log('    - pageStyle:', child.pageStyle);
          console.log('    - routeKey:', child.routeKey);
          console.log('    - parentId:', child.parentId);
          
          // 子路由也根据 pageStyle 选择组件
          let childComponent;
          if (child.pageStyle && pageStyleComponents[child.pageStyle]) {
            childComponent = pageStyleComponents[child.pageStyle];
            console.log(`  ✓ 子路由 ${child.routePath} (${child.name}) 使用 pageStyle: ${child.pageStyle}`);
          } else {
            // 尝试从 pageTemplateS 查找
            const pathKey = child.routePath.replace(/^\//, '').replace(/\//g, '-');
            childComponent = pageTemplateS[pathKey] || pageTemplateS[child.routePath.replace('/', '')];
            
            // 如果仍未找到
            if (!childComponent) {
              // 如果有 routeKey，说明是数据驱动页面，默认使用卡片网格布局
              if (child.routeKey) {
                console.warn(`  ⚠ 子路由 ${child.routePath} (${child.name}) 未配置 pageStyle 但有 routeKey，默认使用卡片网格布局`);
                childComponent = pageStyleComponents['card-grid'];
              } else {
                console.warn(`  ⚠ 子路由 ${child.routePath} (${child.name}) 未配置 pageStyle 和 routeKey，使用默认布局`);
                childComponent = pageStyleComponents['default'];
              }
            }
          }
          
          const childPath = child.routePath.replace(nav.routePath + '/', '');
          console.log(`    - 子路由相对路径: ${childPath}`);
          
          return {
            path: childPath,
            name: `nav-${child.id}`,
            component: childComponent,
            meta: {
              navId: child.id,
              navName: child.name,
              parentNavId: nav.id,
              routeKey: child.routeKey,
              pageStyle: child.pageStyle
            }
          };
        })
      ];
    }
    
    routes.push(route);
  });
  routes.push({
    path: '/product-solution/production-detail',
    name: "production-detail",
    component: pageTemplateS["production-detail"],
  })
  return routes;
}

// 创建路由实例
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: staticRoutes,
});

// 初始化动态路由
export async function setupDynamicRoutes() {
  const dynamicRoutes = await generateDynamicRoutes();
  
  // 添加容器路由
  router.addRoute({
    path: "/",
    name: "yin-container",
    component: () => import("@/views/YinContainer.vue"),
    children: dynamicRoutes,
  });
}

export default router;